import React from 'react';
import { ImgLazyload } from '../index';
import Critical from '../../../public/images/icon-condition.png';
import Doctor from '../../../public/images/icon-doctor.png';
import Treatment from '../../../public/images/icon-treatment.png';
import Placeholder from '../../../public/images/patient-placeholder.png';
import './patientStatus.scss';

export const PatientStatus = ({
  status,
}) => (
  <div className="patient-status d-flex">
    {handleStatus(status)}
  </div>
);
 
export default PatientStatus;

const handleStatus = (status) => {
  switch (status) {
    case 'critical': return (
      <>
        <ImgLazyload src={Critical} className="" />
        <div className="px-2">
          <p className="fs-16 mb-0 text-bold" style={{ color: '#0E5166' }}>Condition Critical</p>
          <p className="fs-12 mb-0" style={{ color: '#0E5166' }}>Treatment ongoing</p>
        </div>
      </>
    );
      break;
    case 'Treatment Started': return (
      <>
        <ImgLazyload src={Treatment} className="" />
        <div className="px-2">
          <p className="fs-16 mb-0 text-bold" style={{ color: '#0E5166' }}>Treatment Started</p>
          <p className="fs-12 mb-0" style={{ color: '#0E5166' }}>Condition Improved</p>
        </div>
      </>
    );
      break;
    case 'Undergoing Treatment': return (
      <>
        <ImgLazyload src={Treatment} className="" />
        <div className="px-2">
          <p className="fs-16 mb-0 text-bold" style={{ color: '#0E5166' }}>undergoing treatment</p>
          <p className="fs-12 mb-0" style={{ color: '#0E5166' }}>Condition Improved</p>
        </div>
      </>
    );
      break;
    case 'Treatment Successful': return (
      <>
        <ImgLazyload src={Doctor} className="" />
        <div className="px-2">
          <p className="fs-16 mb-0 text-bold" style={{ color: '#0E5166' }}>Treatment successful</p>
          <p className="fs-12 mb-0" style={{ color: '#0E5166' }}>Condition Improved</p>
        </div>
      </>
    );
      break;
    case 'Condition Stable': return (
      <>
        <ImgLazyload src={Treatment} className="" />
        <div className="px-2">
          <p className="fs-16 mb-0 text-bold" style={{ color: '#0E5166' }}>treatment successful</p>
          <p className="fs-12 mb-0" style={{ color: '#0E5166' }}>Treatment ongoing</p>
        </div>
      </>
    );
      break;
    case 'recovered': return (
      <>
        <ImgLazyload src={Doctor} className="" />
        <div className="px-2">
          <p className="fs-16 mb-0 text-bold" style={{ color: '#0E5166' }}>Fully recovered</p>
          <p className="fs-12 mb-0" style={{ color: '#0E5166' }}>Condition Improved</p>
        </div>
      </>
    );
      break;
    case 'deceased': return (
      <>
        <ImgLazyload src={Placeholder} className="" />
        <div className="px-2">
          <p className="fs-16 mb-0 text-bold" style={{ color: '#0E5166' }}>Patient deceased</p>
          <p className="fs-12 mb-0" style={{ color: '#0E5166' }}>Condition Regressed</p>
        </div>
      </>
    );
      break;
    default: return '';
      break;
  }
};
